import { Slider } from 'antd-mobile'
import { SliderProps } from 'antd-mobile/es/components/slider'
import './index.less'

const SJSlider: React.FC<SliderProps> = ({
  className,
  value = 0,
  step = 1,
  min = 0,
  max = 1,
  onAfterChange,
  ...props
}) => {
  return (
    <Slider
      className={`sj-slider ${className ?? ''}`}
      value={value}
      max={max}
      min={min}
      step={step}
      onAfterChange={onAfterChange}
      icon=""
      {...props}
    ></Slider>
  )
}

export default SJSlider
